import { useParams } from 'react-router-dom';

import { AppUpdateLinkPage } from '~/components/pages/AppUpdateLinkPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { useNavigate } from '~/components/utils/Navigation';

export const AppUpdateLinkRoute: React.FC = () => {
  const { appId, categoryId } = useParams();
  const navigate = useNavigate();

  if (!appId || !categoryId) {
    navigate('/');

    return null;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppUpdateLinkPage appId={appId} categoryId={categoryId} />
    </DashboardTemplate>
  );
};
